import { render } from "./ConstructorModelMaker.vue?vue&type=template&id=1b210e32&scoped=true"
import script from "./ConstructorModelMaker.vue?vue&type=script&lang=js"
export * from "./ConstructorModelMaker.vue?vue&type=script&lang=js"

import "./ConstructorModelMaker.vue?vue&type=style&index=0&id=1b210e32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b210e32"

export default script